import React from 'react';

export const WalletSvg = () => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 8.00235H3C1.89543 8.00235 1 8.89778 1 10.0023V20.0023C1 21.1069 1.89543 22.0023 3 22.0023H19C20.1046 22.0023 21 21.1069 21 20.0023V10.0023C21 8.89778 20.1046 8.00235 19 8.00235ZM19 8.00235V3.00232C19 1.54774 17.3242 0.579678 16 1.18159L2.25969 8.14384"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
